module.exports = __webpack_public_path__ + "img/156.b65bc3b4.jpg";